<template>
    <svg version="1.1"
         id="Layer_1"
         xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 32 35"
         style="enable-background:new 0 0 32 35;" xml:space="preserve"
         :style="`fill: ${iconColor};`"
         :width="width"
         :height="height">
        <g transform="translate(0,-1020.3622)">
            <path d="M16,1034.4c-2.8,0-5,2.2-5,5s2.2,5,5,5s5-2.2,5-5S18.8,1034.4,16,1034.4z M16,1035.4c2.2,0,4,1.8,4,4s-1.8,4-4,4
                s-4-1.8-4-4C12,1037.1,13.8,1035.4,16,1035.4z"/>
            <path d="M20.7,1039.4l-0.7,0.7l2.3,2.3l0.7-0.7L20.7,1039.4L20.7,1039.4z"/>
            <path d="M21.2,1043.9l-0.7,0.7l1.8,1.8l0.7-0.7L21.2,1043.9z"/>
            <path d="M20.2,1047.9l-0.7,0.7l1.8,1.8l0.7-0.7L20.2,1047.9z"/>
            <path d="M19.2,1050.9l-0.7,0.7l1.8,1.8l0.7-0.7L19.2,1050.9z"/>
            <path d="M15.7,1031.9c-2.7,0.1-5.3,1.7-6.5,4.3c-1.6,3.5-0.4,7.6,2.9,9.6s7.5,1.2,9.8-1.8s2-7.3-0.8-10c-0.2-0.2-0.5-0.2-0.7,0
                s-0.2,0.5,0,0.7l0,0c2.4,2.3,2.7,6,0.7,8.7c-2,2.6-5.7,3.3-8.5,1.6c-2.8-1.7-3.9-5.3-2.5-8.3s4.9-4.5,8-3.4c0.3,0.1,0.5,0,0.6-0.3
                s0-0.5-0.3-0.6l0,0C17.5,1032,16.6,1031.8,15.7,1031.9L15.7,1031.9z"/>
            <path d="M16.9,1029.4c-3.7-0.3-7.4,1.4-9.4,4.7c-0.2,0.2-0.1,0.5,0.1,0.7s0.5,0.1,0.7-0.1l0,0c2.4-4,7.5-5.4,11.7-3.4
                s6.1,7,4.4,11.4s-6.5,6.7-10.9,5.3c-4.5-1.3-7.2-5.9-6.2-10.4c0.1-0.3-0.1-0.5-0.4-0.6s-0.5,0.1-0.6,0.4c-1,5.1,2,10.1,6.9,11.6
                c5,1.5,10.2-1.1,12.2-5.9s-0.2-10.3-4.8-12.6C19.3,1029.8,18.1,1029.5,16.9,1029.4L16.9,1029.4z"/>
            <path d="M15.5,1026.9c-4.7,0.2-9,3-11,7.5c-2.6,6-0.1,13,5.7,16.1c5.8,3,13,1,16.4-4.6s1.9-12.9-3.4-16.7c-0.2-0.2-0.5-0.1-0.7,0.1
                s-0.1,0.5,0.1,0.7l0,0c4.9,3.5,6.3,10.2,3.2,15.4s-9.7,7-15.1,4.2s-7.7-9.2-5.2-14.8s8.7-8.3,14.4-6.3c0.3,0.1,0.5,0,0.6-0.3
                s0-0.5-0.3-0.6C18.6,1027,17,1026.8,15.5,1026.9z"/>
            <path d="M16.7,1024.4c-5.6-0.2-11.1,2.7-13.9,8c-0.1,0.2,0,0.5,0.2,0.7s0.5,0,0.7-0.2l0,0c3.5-6.6,11.5-9.3,18.2-6.2
                c6.8,3.1,9.9,10.9,7.2,17.8s-10.3,10.5-17.4,8.2s-11.1-9.7-9.2-16.9c0.1-0.3-0.1-0.5-0.4-0.6s-0.5,0.1-0.6,0.4l0,0
                c-2,7.7,2.3,15.6,9.8,18.1c7.6,2.5,15.7-1.4,18.6-8.8s-0.5-15.8-7.7-19.1C20.4,1024.9,18.5,1024.5,16.7,1024.4L16.7,1024.4z"/>
            <path d="M3,1034.1c0,0.3-0.2,0.5-0.5,0.5l0,0c-0.3,0-0.5-0.2-0.5-0.5l0,0c0-0.3,0.2-0.5,0.5-0.5S3,1033.8,3,1034.1z"/>
            <path d="M22,1028.7c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5S22,1028.4,22,1028.7z"/>
            <path d="M7.6,1035.9c0,0.3-0.2,0.5-0.5,0.5l0,0c-0.3,0-0.5-0.2-0.5-0.5l0,0c0-0.3,0.2-0.5,0.5-0.5S7.6,1035.6,7.6,1035.9z"/>
            <path d="M20.1,1033.4c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5l0,0C19.9,1032.9,20.1,1033.1,20.1,1033.4
                L20.1,1033.4z"/>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "TrackedByIcon",
        props: {
            width: {
                type: [Number, String],
                default: 18
            },
            height: {
                type: [Number, String],
                default: 18
            },
            iconColor: {
                type: String,
                default: '#211f20'
            }
        }
    }
</script>

<style scoped>
    .st0 {
        fill: #FFFFFF;
    }
</style>
